// extracted by mini-css-extract-plugin
export default {"container":"Part4_container__1DLIr","infoBoxSingle":"Part4_infoBoxSingle__P0dX6","infoBox":"Part4_infoBox__8lcdf"};